
<template>
  <div>
    <Breadcrumbs main="" title="firebase todo"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header firebase-header">
              <h5>User Ranking </h5>
            </div>
            <div class="card-body custom-scrollbar">
              <div class="todo">
                <div class="todo-list-wrapper">
                  <div class="todo-list-container">                  
                    <div class="mark-all-tasks firebase-sm">
                      <div class="form-group m-form__group">
                        <div class="col-xl-12 col-sm-12">
                          <div class="btn-group btn-group-pill" role="group" aria-label="Basic example">
                            <button class="btn btn-success btn-sm" type="button" @click="getThisWeek2(-7)" ><i class="fa fa-chevron-left"></i></button>
                            <button class="btn btn-success btn-sm" type="button">{{getThisWeek()}}</button>
                            <button class="btn btn-success btn-sm" type="button" @click="getThisWeek2(7)" ><i class="fa fa-chevron-right"></i></button>
                          </div>  
                          <div class="btn-group btn-group-pill" role="group" aria-label="Basic example">   
                            
                              <button class="btn btn-success btn-sm" type="button">Keyword</button>
                              <b-form-select v-model="item_usage" :options="usageOptions" id="item_usage" name="item_usage" class="btn btn-success btn-sm" ></b-form-select>
                                                       
                          </div>                                            
                        </div> 

                        
                      </div>
                    </div>
                    <div class="table-responsive datatable-vue m-0 vue-smart">                                      
                      <v-table
                          :data="todolist" class="table"
                          :currentPage.sync="basic.currentPage"
                          :pageSize="10"
                          @totalPagesChanged="basic.totalPages = $event"
                      >
                        <thead slot="head">
                          <th>Rank</th>
                          <th>Fraud User</th>
                          <th>UserUid</th>       
                          <th>Name</th>
                          <th>Profile</th>
                          <th>Country</th>
                          <th>Score</th>
                          <th>Lev.</th>
                          <th>Date</th>
                          <th>Visibility</th>
                          <th>Del</th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <tr v-for="(todo, index) in displayData" :key="index" class="task"  :class="{'completed':todo.status == 'complete'}">                                  
                            <td><b-badge pill variant="success">{{ index+1 }}</b-badge></td>
                            <td></td>
                            <td><b-badge pill variant="success">{{ todo.userUid }} <i class="icon-search"></i></b-badge></td>
                            <td>{{ todo.userName }}</td>
                            <td>{{ todo.userPhotoUrl }}</td>
                            <td>{{ todo.country}}</td>
                            <td>{{ todo.score }}</td>
                            <td>{{ todo.level }}</td>
                            <td>{{ todo.created }}</td>
                            <td>
                              <span @click="taskActive(todo.id,todo.visibility)" class="action-box large complete-btn" title="Mark Complete">
                                <b-badge v-if="todo.visibility==true" pill variant="success">{{ todo.visibility }} <i class="icon-check"></i></b-badge>
                                <b-badge v-else pill variant="secondary">{{ todo.visibility }} <i class="icon-check"></i></b-badge>
                              </span>  
                            </td>
                            <td>
                              <span class="task-action-btn">
                                <span @click="tododelete(todo.id)" class="action-box large delete-btn" title="Delete Task"><i class="icon"><i class="icon-trash"></i></i></span>
                              </span>                            
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      <smart-pagination
                          :currentPage.sync="basic.currentPage"
                          :totalPages="basic.totalPages"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <notifications classes="task" group="Todolist" />
                </div>
              </div>

              <!-- HTML Template for tasks-->
              <script id="task-template " type="tect/template">
                <li class="task">
                  <div class="task-container">
                    <h4 class="task-label"></h4>
                    <span class="task-action-btn">
                      <span class="action-box large delete-btn" title="Delete Task">
                        <i class="icon"><i class="icon-trash"></i></i>
                      </span>
                      <span class="action-box large complete-btn" title="Mark Complete">
                        <i class="icon"><i class="icon-check"></i></i>
                      </span>
                    </span>
                  </div>
                </li>
              </script>
            </div>
          </div>                
        </div>
      </div>
    </div>         
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import { mapState } from "vuex";
  var constants = require('../../constants/manosdk');

  export default {    
    name:'todo',
    data(){

      return {
        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        idfilter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        selectedRows: [],        

        filters: {
            created: { value: '', keys: ['created'] },
            status: { value: '', keys: ['status'] },
        },

        usageOptions:[
            { value:'DAY-1', text: 'DAY-1'},
            { value:'DAY-2', text: 'DAY-2'}
        ]  
      }
    },

    computed: {
      ...mapState({
        todolist: state => state.firebase_rank.todo,
      }),
      formatted(){
        return Vue.filter('date')(this.value)
      }      
    },
    created(){
      this.retrieveTodos();
    },

    methods:{
      getThisWeek()
      {
        var days = constants.days;
        var dateFormat = require('dateformat');
        var curr = new Date();
        curr.setHours(0,0,0,0);
        var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()+days));
        return dateFormat(firstday, "yyyy-mm-dd");
      },
      getThisWeek2(DAYS)
      {
        var days = constants.days+DAYS;
        constants.days = days;
        var dateFormat = require('dateformat');
        var curr = new Date();
        curr.setHours(0,0,0,0);
        var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()+days));
        this.$store.dispatch('firebase_rank/retrieveTodos', days)
        return dateFormat(firstday, "yyyy-mm-dd");
      },      

      retrieveTodos()
      {
        var days = 0;
        this.$store.dispatch('firebase_rank/retrieveTodos', days)
      },
      taskActive(id,status)
      {
        this.$store.dispatch('firebase_rank/taskActive', id)
        this.retrieveTodos();

        if(status != false)
          this.$toasted.show(" Rank visibility is true.", {theme: 'outline', type: 'success', duration: 2000});
           else
          this.$toasted.show(" Rank visibility is false.", {theme: 'outline', type: 'error', duration: 2000});
      },
      tododelete(id)
      {
        this.$store.dispatch('firebase_rank/tododelete', id)
        this.retrieveTodos();
        this.$toasted.show("Task has been deleted.",{theme:'outline', type : 'success',duration:2000});
      }
    }
  }
</script>